import React from 'react'
import { Drawer } from 'antd'

import { server, stringifyDate } from '../../modules'

const Attachment = ({ visible, toggle, attachment }) => {
    return (
        <Drawer
            closable
            maskClosable
            visible={visible}
            onClose={ toggle }
            width={700}>
            <p className="font-extrabold text-3xl mb-0">{ attachment?.title }</p>
            <p className="text-xs mt-0 mb-2">Uploaded by { attachment?.uploadedBy?.name } on { stringifyDate(attachment?.uploadedOn) }</p>
            <p className="text-gray-500 text-xs my-0">Description</p>
            <p className="text-sm mb-2">{ attachment?.description }</p>
            <div className="divide-y divide-light-gray-400">
                {
                    attachment?.type === 'application/pdf' ?
                        <iframe width="100%" height="600px" src={ `${server}/uploads/patient-attachments/${ attachment?.documents[0] }` } />
                    : <img src={ `${server}/uploads/patient-attachments/${ attachment?.documents[0] }` } />
                }
            </div>
        </Drawer>
    )
}

export default Attachment